export const saveWatchProgress = async ({ BeURL, sessionId, time, completed, courseId }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            return {
                success: false,
                message: "Backend URL not provided or invalid"
            }
        }

        if (!sessionId) {
            return {
                success: false,
                message: "Session ID not provided"
            }
        }

        if (typeof time !== 'number' || time < 0) {
            return {
                success: false,
                message: "Invalid time value"
            }
        }

        const body = { sessionId, time, completed: !!completed };

        // Add courseId if provided (for better progress tracking)
        if (courseId) {
            body.courseId = courseId;
        }

        const res = await fetch(`${BeURL}/save-watch-progress`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            return {
                success: false,
                message: `HTTP error! status: ${res.status}`
            }
        }

        const data = await res.json()
        return data

    } catch (error) {
        console.error("Error saving watch progress:", error)
        return {
            success: false,
            message: "An error occurred while saving progress"
        }
    }
}

export const getWatchProgress = async ({ BeURL, courseId }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            return {
                success: false,
                message: "Backend URL not provided or invalid",
                progress: {}
            }
        }

        if (!courseId) {
            return {
                success: false,
                message: "Course ID not provided",
                progress: {}
            }
        }

        const res = await fetch(`${BeURL}/get-watch-progress?courseId=${courseId}`, {
            method: "GET",
            credentials: "include"
        })

        if (!res.ok) {
            return {
                success: false,
                message: `HTTP error! status: ${res.status}`,
                progress: {}
            }
        }

        const data = await res.json()
        return data

    } catch (error) {
        console.error("Error getting watch progress:", error)
        return {
            success: false,
            message: "An error occurred while getting progress",
            progress: {}
        }
    }
}

export const getCourseProgress = async ({ BeURL, courseId }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            return {
                success: false,
                message: "Backend URL not provided or invalid",
                progress: {
                    percentage: 0,
                    completedVideos: 0,
                    totalVideos: 0
                }
            }
        }

        if (!courseId) {
            return {
                success: false,
                message: "Course ID not provided",
                progress: {
                    percentage: 0,
                    completedVideos: 0,
                    totalVideos: 0
                }
            }
        }

        const res = await fetch(`${BeURL}/get-course-progress?courseId=${courseId}`, {
            method: "GET",
            credentials: "include"
        })

        if (!res.ok) {
            return {
                success: false,
                message: `HTTP error! status: ${res.status}`,
                progress: {
                    percentage: 0,
                    completedVideos: 0,
                    totalVideos: 0
                }
            }
        }

        const data = await res.json()
        return data

    } catch (error) {
        console.error("Error getting course progress:", error)
        return {
            success: false,
            message: "An error occurred while getting course progress",
            progress: {
                percentage: 0,
                completedVideos: 0,
                totalVideos: 0
            }
        }
    }
}

export const markAsCompleted = async ({ BeURL, sessionId, courseId }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            return {
                success: false,
                message: "Backend URL not provided or invalid"
            }
        }

        if (!sessionId) {
            return {
                success: false,
                message: "Session ID not provided"
            }
        }

        const res = await fetch(`${BeURL}/mark-as-completed`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ sessionId, courseId })
        })

        if (!res.ok) {
            return {
                success: false,
                message: `HTTP error! status: ${res.status}`
            }
        }

        const data = await res.json()
        return data

    } catch (error) {
        console.error("Error marking as completed:", error)
        return {
            success: false,
            message: "An error occurred while marking as completed"
        }
    }
}
